import styled from 'styled-components';
import { getToken, LinkButton } from '@optimus-web/core';

export const DownloadButtonElement = styled(LinkButton)`
    text-decoration: none;

    &:hover,
    &:focus {
        text-decoration: none;
        color: ${getToken('textStaticPrimary')};
    }
`;
